import React from "react";
import { Drawer } from "antd";
import "./style.scss";

interface DrawerWrapperProps {
  open: boolean;
  onClose: (
    e: React.MouseEvent<Element> | React.KeyboardEvent<Element>
  ) => void;
  title?: string;
  className?: string;
  buttonLabel?: string;
  children: React.ReactNode;
  width?: number | string;
  placement?: "top" | "right" | "bottom" | "left";
  closable?: boolean;
  extra?: React.ReactNode;
  footer?: React.ReactNode;
}

const DrawerWrapper: React.FC<DrawerWrapperProps> = ({
  open,
  onClose,
  title = "Basic Drawer",
  children,
  width = 400,
  placement = "right",
  closable = true,
  extra,
  footer,
  className,
}) => {
  return (
    <>
      <Drawer
        className={`drawer-frame ${className}`}
        title={title}
        closable={closable}
        onClose={onClose}
        open={open}
        width={width}
        extra={extra}
        placement={placement}
        footer={footer}
      >
        {children}
      </Drawer>
    </>
  );
};

export default DrawerWrapper;
